module.exports = __webpack_public_path__ + "img/muxiangshanheizhurou.3899a3d6.jpg";